module.exports = __webpack_public_path__ + "static/media/chords.42b7b7d8.m4a";